(function() {
  if (window.__sizeChartNormalizerInitialized) return;
  window.__sizeChartNormalizerInitialized = true;

  const ACCORDION_SELECTOR = '.product__accordion--size-chart .accordion__content';

  function clearCellSizing(el) {
    if (!el) return;
    el.removeAttribute('width');
    el.removeAttribute('height');

    el.style.width = '';
    el.style.minWidth = '';
    el.style.maxWidth = '';
    el.style.height = '';
    el.style.minHeight = '';
    el.style.maxHeight = '';
  }

  function markRows(table) {
    const rows = table.querySelectorAll('tr');
    rows.forEach((row, rowIndex) => {
      row.classList.remove('size-chart-row--header', 'size-chart-row--body');
      const cells = Array.from(row.children).filter((cell) => cell.tagName === 'TH' || cell.tagName === 'TD');
      const hasTh = cells.some((cell) => cell.tagName === 'TH');
      const isHeader = hasTh || rowIndex === 0;

      row.classList.add(isHeader ? 'size-chart-row--header' : 'size-chart-row--body');
      cells.forEach(clearCellSizing);
    });
  }

  function normalizeTable(table) {
    clearCellSizing(table);

    table.querySelectorAll('colgroup, col').forEach((col) => col.remove());
    markRows(table);
  }

  function normalizeSizeCharts(root) {
    if (!root) return;

    root.querySelectorAll(ACCORDION_SELECTOR).forEach((content) => {
      content.querySelectorAll('table').forEach((table) => normalizeTable(table));
    });
  }

  function bootstrap() {
    normalizeSizeCharts(document);

    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
          if (!(node instanceof Element)) return;

          if (node.matches?.(ACCORDION_SELECTOR)) {
            normalizeSizeCharts(node.parentElement || node);
            return;
          }

          if (node.querySelector?.(ACCORDION_SELECTOR)) {
            normalizeSizeCharts(node);
          }
        });
      });
    });

    observer.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootstrap);
  } else {
    bootstrap();
  }

  document.addEventListener('shopify:section:load', (event) => {
    normalizeSizeCharts(event.target);
  });

  document.addEventListener('page:loaded', () => {
    normalizeSizeCharts(document);
  });
})();
